import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> A-Frame Sign Designs </h1>

    
    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/june2020_1.jpeg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/june2020_2.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/wedding2.jpeg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/spring2.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/july2020.jpg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/vday1.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/sale1.jpeg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/psPerks3.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/leaf2.jpeg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/bogo.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/lettering/Aframe/opening1.jpeg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/lettering/Aframe/opening3.jpeg')} data-skip-gallery/>
        </div>
    </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.